import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'react-bootstrap'
import {graphql, useStaticQuery } from "gatsby";
import TrendingSingleItems from '../../../components/trending-article-item';
import TrendingSingleLargeItems from '../../../components/trending-article-large-item';
import {
    TrendingArticleArea,
    TrendingArticleRow,
    TrendingArticleLeftSide,
    TrendingArticleRightSide
} from "./style";


const TredingArticle = props => {
    // const tredingArticleQuery = useStaticQuery(graphql`
    //     query TredingArticleQueryQuery {
    //         smallTredingArticle: allMarkdownRemark(
    //             sort: {fields: [frontmatter___date], order: DESC},
    //             filter: {frontmatter: {is_trending_article: {eq: true}}},
    //             limit: 3
    //         ) {
    //             edges {
    //                 node {
    //                     id
    //                     frontmatter {
    //                         title
    //                         video_link
    //                         categories {
    //                             name
    //                             color
    //                         }
    //                         date(formatString: "DD-MM-YYYY")
    //                         smallImage: thume_image {
    //                             childImageSharp {
    //                                 gatsbyImageData(width: 100, height: 169, layout: CONSTRAINED, quality: 100)
    //                             }
    //                         }
    //                         thume_image {
    //                             childImageSharp {
    //                                 gatsbyImageData(width: 160, height: 160, layout: CONSTRAINED, quality: 100)
    //                             }
    //                         }
    //                     }
    //                     fields {
    //                         slug
    //                         authorId
    //                         dateSlug
    //                     }
    //                     excerpt(pruneLength: 225)
    //                 }
    //             }
    //         }
    //         largeTredingArticle: allMarkdownRemark(
    //             sort: {fields: [frontmatter___date], order: DESC},
    //             filter: {frontmatter: {is_trending_article: {eq: true}}},
    //             limit: 3,
    //             skip: 3
    //           ) {
    //             edges {
    //                 node {
    //                     id
    //                     frontmatter {
    //                         title
    //                         date(formatString: "DD-MM-YYYY")
    //                         video_link
    //                         categories {
    //                             name
    //                             color
    //                         }
    //                         smallImage: thume_image {
    //                             childImageSharp {
    //                                 gatsbyImageData(width: 100, height: 169, layout: CONSTRAINED, quality: 100)
    //                             }
    //                         }
    //                         thume_image {
    //                             childImageSharp {
    //                                 gatsbyImageData(width: 315, height: 160, layout: CONSTRAINED, quality: 100)
    //                             }
    //                         }
    //                     }
    //                     fields {
    //                         slug
    //                         authorId
    //                         dateSlug
    //                     }
    //                     excerpt(pruneLength: 225)
    //                 }
    //             }
    //         }
    //
    //     }
    // `);
    const tredingArticleQuery = useStaticQuery(graphql`
query TredingArticleQueryQuery {
  smallTredingArticle: allMongodbArchivosBlogDetails(
    sort: {fields: [jfrontmatter___date], order: DESC}
    filter: {jfrontmatter: {is_trending_article: {eq: true}}, esPublicado: {eq: true}}
    limit: 3
  ) {
    edges {
      node {
        id
        jfrontmatter {
          title
          categories {
            name
            color
          }
          date(formatString: "DD-MM-YYYY")
        }
        jfields {
          slug
          authorId
          dateSlug
        }
        jexcerpt
        smallImage: localThume {
          childImageSharp {
            gatsbyImageData(width: 100, height: 169, layout: CONSTRAINED, quality: 100)
          }
        }
        localThume {
          childImageSharp {
            gatsbyImageData(width: 160, height: 160, layout: CONSTRAINED, quality: 100)
          }
        }
      }
    }
  }
  largeTredingArticle: allMongodbArchivosBlogDetails(
    sort: {fields: [jfrontmatter___date], order: DESC}
    filter: {jfrontmatter: {is_trending_article: {eq: true}}, esPublicado: {eq: true}}
    limit: 3
    skip: 3
  ) {
    edges {
      node {
        id
        jfrontmatter {
          title
          date(formatString: "DD-MM-YYYY")
          categories {
            name
            color
          }
        }
        jfields {
          slug
          authorId
          dateSlug
        }
        jexcerpt
        smallImage: localThume {
          childImageSharp {
            gatsbyImageData(width: 100, height: 169, layout: CONSTRAINED, quality: 100)
          }
        }
        localThume {
          childImageSharp {
            gatsbyImageData(width: 160, height: 160, layout: CONSTRAINED, quality: 100)
          }
        }
      }
    }
  }
}

    `);

    const smalltredingArticleData = tredingArticleQuery.smallTredingArticle.edges;
    const largetredingArticleData = tredingArticleQuery.largeTredingArticle.edges;

    return (
        <TrendingArticleArea>
            <Container>
                <Row>
                    <Col lg={8} xs={7}>
                        <div className="section-title mb-40">
                            <h3>Articulos más visitados</h3>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <TrendingArticleRow>
                            <TrendingArticleLeftSide>
                                {smalltredingArticleData && smalltredingArticleData.map((item, index) => {
                                    return (
                                        <TrendingSingleItems
                                            key={`trending-${index}`}
                                            title={item.node.jfrontmatter.title}
                                            thume_image={item.node.localThume}
                                            small_image={item.node.smallImage}
                                            categories={item.node.jfrontmatter.categories}
                                            slug={item.node.jfields.slug}
                                            authorSlug={item.node.jfields.authorId}
                                            authorId={item.node.jfields.authorId}
                                            postAuthor={item.node.jfrontmatter.author}
                                            body={item.node.jexcerpt}
                                            date={item.node.jfrontmatter.date}
                                            dateSlug={item.node.jfields.dateSlug}
                                        />
                                    );
                                })}
                            </TrendingArticleLeftSide>

                            <TrendingArticleRightSide>

                                {largetredingArticleData && largetredingArticleData.map((followingBlog, i) => {
                                    return (
                                        <TrendingSingleLargeItems
                                            key={`largetrending-${i}`}
                                            title={followingBlog.node.jfrontmatter.title}
                                            thume_image={followingBlog.node.localThume}
                                            small_image={followingBlog.node.smallImage}
                                            categories={followingBlog.node.jfrontmatter.categories}
                                            slug={followingBlog.node.jfields.slug}
                                            authorSlug={followingBlog.node.jfields.authorId}
                                            authorId={followingBlog.node.jfields.authorId}
                                            postAuthor={followingBlog.node.jfrontmatter.author}
                                            body={followingBlog.node.jexcerpt}
                                            date={followingBlog.node.jfrontmatter.date}
                                            dateSlug={followingBlog.node.jfields.dateSlug}
                                        />
                                    );
                                })}

                            </TrendingArticleRightSide>

                        </TrendingArticleRow>

                    </Col>
                </Row>
            </Container>
        </TrendingArticleArea>
    )
}

TredingArticle.propTypes = {

}

export default TredingArticle
